import React, { useEffect, useState } from 'react';
import { Menu, MenuItem, TextField, Typography } from '@mui/material';

const ColumnFilter = ({ anchorEl, onClose, onFilterChange, columnType, filterValues }) => {
 const [startsWithValue, setStartsWithValue] = useState('');
 const [endsWithValue, setEndsWithValue] = useState('');
 const [containsValue, setContainsValue] = useState('');
 const [notContainsValue, setNotContainsValue] = useState('');
 const [equalValue, setEqualValue] = useState('');
 const [startDate, setStartDate] = useState('');
 const [endDate, setEndDate] = useState('');
 const [rangeStart, setRangeStart] = useState('');
 const [rangeEnd, setRangeEnd] = useState('');

 useEffect(() => {
  if (filterValues && filterValues.value) {
   if (filterValues.type === 'specificDate') {
    setEqualValue(filterValues.value);
   } else if (filterValues.type === 'startDate') {
    setStartDate(filterValues.value);
   } else if (filterValues.type === 'endDate') {
    setEndDate(filterValues.value);
   } else if (filterValues.type === 'dateRange') {
    setRangeStart(filterValues.value);
    setRangeEnd(filterValues.extraValue);
   } else {
    setEqualValue(filterValues.type === 'equal' ? filterValues.value : '');
    setStartsWithValue(filterValues.type === 'startsWith' ? filterValues.value : '');
    setEndsWithValue(filterValues.type === 'endsWith' ? filterValues.value : '');
    setContainsValue(filterValues.type === 'contains' ? filterValues.value : '');
    setNotContainsValue(filterValues.type === 'notContains' ? filterValues.value : '');
   }
  }
 }, [filterValues]);

 const handleSort = (order) => {
  onFilterChange(order);
  onClose();
 };

 const handleFilterChange = (type, value, extraValue = null) => {
  onFilterChange(type, value, extraValue);
 };

 const handleKeyDown = (e) => {
  e.stopPropagation(); // מונע את מעבר הפוקוס לשדה אחר
 };

 return (
  <Menu
   anchorEl={anchorEl}
   open={Boolean(anchorEl)}
   onClose={onClose}
   anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'right',
   }}
   transformOrigin={{
    vertical: 'top',
    horizontal: 'right',
   }}
  >
   {/* סינון לפי א'-ב' */}
   {columnType === 'text' && (
    <div>
     <MenuItem onClick={() => handleSort('asc')}>סדר א'-ב'</MenuItem>
     {/* סינון לפי ב'-א' */}
     <MenuItem onClick={() => handleSort('desc')}>סדר ב'-א'</MenuItem>
     {/* סינון לפי ערך שווה */}
     <MenuItem>
      <TextField
       label="שווה ל"
       variant="outlined"
       size="small"
       value={equalValue}
       onChange={(e) => {
        setEqualValue(e.target.value);
        handleFilterChange('equal', e.target.value);
       }}
       onKeyDown={handleKeyDown}
       style={{ marginRight: '10px', minWidth: '150px' }}
      />
     </MenuItem>
     {/* סינון לפי ערך שמתחיל ב */}
     <MenuItem>
      <TextField
       label="מתחיל ב"
       variant="outlined"
       size="small"
       value={startsWithValue}
       onChange={(e) => {
        setStartsWithValue(e.target.value);
        handleFilterChange('startsWith', e.target.value);
       }}
       onKeyDown={handleKeyDown}
       style={{ marginRight: '10px', minWidth: '150px' }}
      />
     </MenuItem>
     {/* סינון לפי ערך שמסתיים ב */}
     <MenuItem>
      <TextField
       label="מסתיים ב"
       variant="outlined"
       size="small"
       value={endsWithValue}
       onChange={(e) => {
        setEndsWithValue(e.target.value);
        handleFilterChange('endsWith', e.target.value);
       }}
       onKeyDown={handleKeyDown}
       style={{ marginRight: '10px', minWidth: '150px' }}
      />
     </MenuItem>
     {/* סינון לפי ערך שמכיל */}
     <MenuItem>
      <TextField
       label="מכיל"
       variant="outlined"
       size="small"
       value={containsValue}
       onChange={(e) => {
        setContainsValue(e.target.value);
        handleFilterChange('contains', e.target.value);
       }}
       onKeyDown={handleKeyDown}
       style={{ marginRight: '10px', minWidth: '150px' }}
      />
     </MenuItem>
     {/* סינון לפי ערך שלא מכיל */}
     <MenuItem>
      <TextField
       label="לא מכיל"
       variant="outlined"
       size="small"
       value={notContainsValue}
       onChange={(e) => {
        setNotContainsValue(e.target.value);
        handleFilterChange('notContains', e.target.value);
       }}
       onKeyDown={handleKeyDown}
       style={{ marginRight: '10px', minWidth: '150px' }}
      />
     </MenuItem>
    </div>
   )}
   {/* סינון לתאריכים */}
   {columnType === 'date' && (
    <div>
     <MenuItem onClick={() => handleSort('oldest')}>
      <Typography style={{ marginRight: '10px' }}>מהישן לחדש</Typography>
     </MenuItem>
     <MenuItem onClick={() => handleSort('newest')}>
      <Typography style={{ marginRight: '10px' }}>מהחדש לישן</Typography>
     </MenuItem>
     {/* סינון לפי תאריך ספציפי */}
     <MenuItem>
      {console.log('15:', equalValue)}
      <TextField
       label="בתאריך"
       type="date"
       variant="outlined"
       size="small"
       style={{ width: 340 }}
       value={equalValue}
       onChange={(e) => {
        console.log('16:', equalValue, e.target.value);
        setEqualValue(e.target.value);
        onFilterChange('specificDate', e.target.value);
       }}
       InputLabelProps={{
        shrink: true,
       }}
      />
     </MenuItem>
     {/* סינון החל מ */}
     <MenuItem>
      <TextField
       label="החל מ"
       type="date"
       variant="outlined"
       size="small"
       style={{ width: 340 }}
       value={startDate}
       onChange={(e) => {
        setStartDate(e.target.value);
        onFilterChange('startDate', e.target.value);
       }}
       InputLabelProps={{
        shrink: true,
       }}
      />
     </MenuItem>
     {/* סינון לכל המאוחר */}
     <MenuItem>
      <TextField
       label="לכל המאוחר"
       type="date"
       variant="outlined"
       size="small"
       value={endDate}
       style={{ width: 340 }}
       onChange={(e) => {
        setEndDate(e.target.value);
        onFilterChange('endDate', e.target.value);
       }}
       InputLabelProps={{
        shrink: true,
       }}
      />
     </MenuItem>
     {/* סינון לפי טווח תאריכים */}
     <MenuItem>
      <TextField
       label="מתאריך"
       type="date"
       variant="outlined"
       size="small"
       style={{ width: 170 }}
       value={rangeStart}
       onChange={(e) => {
        setRangeStart(e.target.value);
        onFilterChange('dateRange', e.target.value, rangeEnd);
       }}
       InputLabelProps={{
        shrink: true,
       }}
      />
      <TextField
       label="עד תאריך"
       type="date"
       variant="outlined"
       size="small"
       style={{ width: 170 }}
       value={rangeEnd}
       onChange={(e) => {
        setRangeEnd(e.target.value);
        onFilterChange('dateRange', rangeStart, e.target.value);
       }}
       InputLabelProps={{
        shrink: true,
       }}
      />
     </MenuItem>
    </div>
   )}
  </Menu>
 );
};

export default ColumnFilter;
